import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, HeartHandshake, Brain } from 'lucide-react';

const VALUES = [
  {
    icon: ShieldCheck,
    title: 'Real Self-Defense',
    body: 'Kempo is built for the real world — not for show. Striking, blocks, joint locks and flow drills that actually work under pressure.',
  },
  {
    icon: Brain,
    title: 'Mind, Body, Spirit',
    body: 'The three pillars on our patch. Focus, conditioning, and character — trained together until they become one.',
  },
  {
    icon: HeartHandshake,
    title: 'Family-First Karate School',
    body: 'Veteran-founded in 1980. Every student is treated like family — a community kids look up to and adults trust.',
  },
];

const About = () => (
  <section id="about" className="relative py-16 sm:py-20" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="lg:col-span-5"
      >
        <span className="font-display uppercase tracking-[0.22em] text-[11px] text-[color:var(--neon-red)]">
          Since 1980 · Veteran &amp; Family-Owned
        </span>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl text-white tracking-tight leading-tight">
          Karate in Colorado Springs, since 1980.
          <br />
          <span className="text-white/70">Traditional Kempo. Real-world self-defense.</span>
        </h2>
        <p className="mt-5 text-white/75 leading-relaxed">
          Veteran-founded in 1980 and still family-run today, Universal Kempo Karate is more
          than a dojo — it&#39;s a community. Every student is treated like family: kids build
          confidence, teens sharpen discipline, and adults train alongside instructors who
          genuinely care. Real Kempo, real progress, real people.
        </p>
      </motion.div>

      <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-4">
        {VALUES.map((v, i) => (
          <motion.div
            key={v.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: 0.05 * i }}
            className="panel rounded-2xl p-5 light-trail hover:border-[color:var(--neon-red)]/40 transition-colors"
            data-testid={`about-value-${i}`}
          >
            <v.icon className="h-6 w-6 text-[color:var(--neon-red)]" />
            <h3 className="mt-4 font-display text-white text-lg tracking-tight">{v.title}</h3>
            <p className="mt-2 text-sm text-white/70 leading-relaxed">{v.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default About;
